import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <RankingSection />
        <UpdatesSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <FaqSection />
        <FeaturesSection />
        <ContactSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}